
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 90 91","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.629 57.675c10.697 0 19.368-8.643 19.368-19.305 0-10.662-8.671-19.306-19.368-19.306S10.26 27.707 10.26 38.37c0 10.662 8.671 19.306 19.368 19.306z","stroke":"#fff","stroke-width":"3","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M54.734 19.783a19.43 19.43 0 0115.859 2.428 19.338 19.338 0 015.76 5.829 19.248 19.248 0 012.197 15.842 19.289 19.289 0 01-3.957 7.168 19.365 19.365 0 01-6.581 4.89 19.425 19.425 0 01-8.023 1.736","stroke":"currentColor","stroke-width":"3","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M2.813 71.56A32.75 32.75 0 0114.52 61.353a32.868 32.868 0 0130.219-.002 32.753 32.753 0 0111.709 10.205","stroke":"#fff","stroke-width":"3","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M59.995 57.675a32.823 32.823 0 0115.112 3.673 32.705 32.705 0 0111.706 10.21","stroke":"currentColor","stroke-width":"3","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    